import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appTimeFormat]'
})
export class TimeFormatDirective {
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    let inputValue = this.el.nativeElement.value;

    inputValue = inputValue.replace(/[^0-9:]/g, '');

    if (inputValue.length === 2 && !inputValue.includes(':')) {
      inputValue += ':';
    }

    const parts = inputValue.split(':');

    if (parts[0]?.length > 2) {
      parts[0] = parts[0].slice(0, 2);
    }

    if (parts[0] && (+parts[0] < 0 || +parts[0] > 23)) {
      parts[0] = '23';
    }

    if (parts[1]?.length > 2) {
      parts[1] = parts[1].slice(0, 2);
    }

    if (parts[1] && (+parts[1] < 0 || +parts[1] > 59)) {
      parts[1] = '59';
    }

    this.el.nativeElement.value = parts.join(':');
  }

  @HostListener('keydown', ['$event'])
  handleBackspace(event: KeyboardEvent) {
    if (event.key === 'Backspace') {
      const cursorPos = this.el.nativeElement.selectionStart;
      let inputValue = this.el.nativeElement.value;

      if (cursorPos === 3 && inputValue[cursorPos - 1] === ':') {
        this.el.nativeElement.value =
          inputValue.slice(0, cursorPos - 1) + inputValue.slice(cursorPos);
        this.el.nativeElement.setSelectionRange(cursorPos - 1, cursorPos - 1);
        event.preventDefault();
      }
    }
  }

  @HostListener('blur')
  onBlur() {
    let inputValue = this.el.nativeElement.value;

    if (inputValue && inputValue.split(':').length === 1) {
      this.el.nativeElement.value += ':00';
    }
  }
}